export const UPDATE_CONNECTION_STATUS = 'WS:UPDATE_STATUS';
export const CLEAR_NOTIFICATIONS = 'WS:CLEAR_NOTIFICATIONS';
export const APPEND_NOTIFICATIONS = 'WS:APPEND_NOTIFICATIONS';
export const UPDATE_NOTIFICATIONS = 'WS:UPDATE_NOTIFICATIONS';
export const UPDATE_ENTITIES = 'WS:UPDATE_ENTITIES';
